import { schema } from 'normalizr';
import {
  RESOURCE_TYPE_DATA_SET,
  RESOURCE_TYPE_SOURCE,
  RESOURCE_TYPE_SINK,
  RESOURCE_TYPE_USER,
} from '../constants/resourceTypes';
import { SCHEMA_TYPE_API_KEY } from '../constants/schemaTypes';
import userSchema from './user';

export const apiKeySchema = new schema.Entity(
  SCHEMA_TYPE_API_KEY,
  {
    owner: userSchema,
    user: userSchema,
  },
  {
    processStrategy: (value, parent, key) => {
      const newValue = { ...value };

      if (value.data_set_id) {
        newValue.resourceType = RESOURCE_TYPE_DATA_SET;
        newValue.resourceId = value.data_set_id;
      } else if (value.data_source_id) {
        newValue.resourceType = RESOURCE_TYPE_SOURCE;
        newValue.resourceId = value.data_source_id;
      } else if (value.data_sink_id) {
        newValue.resourceType = RESOURCE_TYPE_SINK;
        newValue.resourceId = value.data_sink_id;
      } else if (value.user_id) {
        newValue.resourceType = RESOURCE_TYPE_USER;
        newValue.resourceId = value.user_id;
      }

      return newValue;
    },
  },
);

export const apiKeyByResourceTypeSchema = new schema.Values(
  {
    data_sets: [apiKeySchema],
    data_sources: [apiKeySchema],
    data_sinks: [apiKeySchema],
    users: [apiKeySchema],
  },
  (value, parent, key) => key,
);
